import { useMutation } from "react-query";
import { searchIdentitiesById } from "src/shared/data-access/wsConsumers/gateway";
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { AxiosError } from "axios";
import { Dispatch, SetStateAction } from "react";

export const useSearchIdentitiesById = (
  setHasCheckedIdentitySuccessfully?: Dispatch<SetStateAction<boolean>>,
) => {
  const { t } = useTranslation();
  return useMutation({
    mutationKey: "searchIdentitiesById",
    mutationFn: searchIdentitiesById,
    onSuccess: (data) => {
      const message: string = data?.data.isActive
        ? t("Ο Αριθμός Δελτίου Ταυτότητας είναι ενεργός!")
        : t("Ο Αριθμός Δελτίου Ταυτότητας δεν είναι ενεργός.");
      const variant: "success" | "warning" = data?.data.isActive
        ? "success"
        : "warning";
      if (setHasCheckedIdentitySuccessfully) {
        setHasCheckedIdentitySuccessfully(data?.data.isActive);
      }
      enqueueSnackbar(message, {
        variant: variant,
      });
    },
    onError: (error: AxiosError<string>) => {
      if (setHasCheckedIdentitySuccessfully) {
        setHasCheckedIdentitySuccessfully(false);
      }
      enqueueSnackbar(error?.response?.data, {
        variant: "warning",
      });
    },
  });
};
